var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1323 -496)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "none",
    width: 18,
    height: 16,
    transform: "translate(1323 496)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1323.004 498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M173.016,170.667a2.349,2.349,0,1,0,2.349,2.349A2.351,2.351,0,0,0,173.016,170.667Z",
    transform: "translate(-164.404 -167.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M8.612,74.667A9.259,9.259,0,0,0,0,80.539a9.252,9.252,0,0,0,17.224,0A9.256,9.256,0,0,0,8.612,74.667Zm0,9.787a3.915,3.915,0,1,1,3.915-3.915A3.916,3.916,0,0,1,8.612,84.454Z",
    transform: "translate(0 -74.667)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ae9bce479e644e4181fa34b783f54824.svg";
export { ForwardRef as ReactComponent };